export const REQUEST_EDITRESEARCHERDATAGENPOOL = 'REQUEST_EDITRESEARCHERDATAGENPOOL';
export const EDITRESEARCHERDATAGENPOOL_RECEIVED = 'EDITRESEARCHERDATAGENPOOL_RECEIVED';

